import {
  iFirestoreDatabase,
  iFirestoreUserModel,
  iFirestoreGameModel,
  iFirestoreReviewModel,
  iFirestoreProfileModel,
} from './firestore.types';
import { FirestoreUserModel } from './models/firestore-user-model';
import { FirestoreGameModel } from './models/firestore-game-model';
import { FirestoreReviewModel } from './models/firestore-review-model';
import { FirestoreProfileModel } from './models/firestore-profile-model';

export class FirestoreDatabase implements iFirestoreDatabase {
  public user: iFirestoreUserModel;

  public profile: iFirestoreProfileModel;

  public game: iFirestoreGameModel;

  public review: iFirestoreReviewModel;

  constructor(
    db: firebase.firestore.Firestore,
  ) {
    this.user = new FirestoreUserModel(db);
    this.game = new FirestoreGameModel(db);
    this.review = new FirestoreReviewModel(db);
    this.profile = new FirestoreProfileModel(db);
  }
}
